export default __webpack_public_path__ + "static/media/intarestdashboard.999fce85.svg";